import React from 'react';
import { Typography, Button, Container, Box } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom'; // Assuming you're using React Router for navigation

function NoPermission() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  const handleGoHome = () => {
    navigate('/'); // Navigate to the home page
  };

  return (
    <Container maxWidth="xxl" sx={{ mt: 8, textAlign: 'center' }}>
      {/* <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Lock sx={{ fontSize: 80, color: 'error.main' }} />
      </Box> */}
      {/* <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary' }}>
        Access Denied
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        Sorry, you don't have permission to view this page. Please contact your administrator if you believe this is an error.
      </Typography> */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        {/* <Button
          variant="outlined"
          color="primary"
          onClick={handleGoBack}
          sx={{ textTransform: 'none', fontWeight: 'bold' }}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoHome}
          sx={{ textTransform: 'none', fontWeight: 'bold' }}
        >
          Go to Home
        </Button> */}
      </Box>
    </Container>
  );
}

export default NoPermission;